import isCardExpired from '@anm//helpers/subscription/isCardExpired';
import compact from 'lodash/fp/compact';
import { useSelector } from 'react-redux';

import { subscriptionSelectors } from '../../../../store/modules/subscription';

const useCardExpiredDate = () => {
  const card = useSelector(subscriptionSelectors.selectCard);
  const tokenCard = useSelector(subscriptionSelectors.selectStripeTokenCard);

  if (card) {
    const { expires } = card;
    const [month, year] = expires.split('/');

    return [month, year];
  }

  if (tokenCard) {
    const { exp_month, exp_year } = tokenCard;
    return [exp_month, exp_year];
  }
};

const useCardExpiredError = () => {
  const errorMessage =
    'Unfortunately, your card has been expired. Please use a different card.';
  const expireDate = useCardExpiredDate();

  if (!expireDate) return null;

  const [month, year] = expireDate;

  return isCardExpired(+year, +month, null) ? errorMessage : null;
};

const useErrors = () => {
  const cardExpiredError = useCardExpiredError();

  const stripeTokenError = useSelector(
    subscriptionSelectors.selectStripeTokenError
  );

  const subscriptionListError = useSelector(
    subscriptionSelectors.selectSubscriptionListError
  );

  const subscriptionChangeError = useSelector(
    subscriptionSelectors.selectSubscriptionChangeError
  );

  const subscriptionCalculateError = useSelector(
    subscriptionSelectors.selectSubscriptionCalculateError
  );

  const cardUpdateErrors = useSelector(
    subscriptionSelectors.selectCardUpdateError
  );

  const errors = [
    cardExpiredError,
    stripeTokenError?.message,
    subscriptionListError?.message,
    subscriptionChangeError?.message,
    subscriptionCalculateError?.message,
    cardUpdateErrors?.message
  ];

  return compact(errors);
};

export default useErrors;
